import React from 'react';
import { Icon } from './Icon.js';
export const IconProfileBasicFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "m14.25,15H3.75c-.4141,0-.75.3359-.75.75s.3359.75.75.75h10.5c.4141,0,.75-.3359.75-.75s-.3359-.75-.75-.75Z", fill: "currentColor", strokeWidth: "0", "data-color": "color-2" }),
        React.createElement("circle", { cx: "9", cy: "7.5", r: "6", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconProfileBasicFill18.js.map